import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { getUserId } from '../lib/liff';
import BookingView, { type BookingDetail } from '../components/BookingView';
import BottomNav from '../components/BottomNav';
import LoadingSpinner from '../components/LoadingSpinner';
import ErrorMessage from '../components/ErrorMessage';
import { Screen, TopBar, formatDate } from '../components/ui';

export default function BookingDetailPage() {
  const { bookingId } = useParams<{ bookingId: string }>();
  const navigate = useNavigate();
  const [booking, setBooking] = useState<BookingDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!bookingId) return;
    const lineUserId = getUserId();
    api.getBooking(bookingId, lineUserId || undefined).then((response) => {
      if (response.success && response.data) setBooking(response.data);
      else setError(response.error || '找不到這筆報名');
      setLoading(false);
    });
  }, [bookingId]);

  if (loading) return <LoadingSpinner />;
  if (error || !booking) return <ErrorMessage message={error || '找不到這筆報名'} />;

  return (
    <Screen className="pb-28">
      <TopBar
        onBack={() => (window.history.length > 1 ? navigate(-1) : navigate('/my-bookings'))}
        title={booking.eventTitle}
        subtitle={formatDate(booking.eventDate, { year: 'numeric', month: 'numeric', day: 'numeric', weekday: 'short' })}
      />
      <div className="px-5 pt-2">
        <BookingView booking={booking} />
      </div>
      <BottomNav active="my" />
    </Screen>
  );
}
